<template>
    <div class="wrapper" style="height:100%;">
        <div class="contentWebsite" style="height:100%;">
            <v-expand-transition>
                <router-view />
            </v-expand-transition>
        </div>
    </div>
</template>

<script>
export default {
    name:"Library",
    components: {},
    data() {
        return {}
    },
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('base/SET_SUB_MENU', []);
        next();
    },
    methods: {},
    computed: {},
    mounted() {},
}
</script>
